import * as yup from 'yup'

import { 
    EMAIL_REGEX_FORMAT,
    trimmedInputValues,
    capitalizeWordsInValue,
} from '../utils';

const EditUserProfileValidationSchema = yup.object().shape({
    firstName: yup.string()
        .transform((value) => capitalizeWordsInValue(value))
        .required('Please enter first name')
        .transform((value) => trimmedInputValues(value)),
    
    lastName: yup.string()
        .transform((value) => capitalizeWordsInValue(value))
        .required('Please enter last name')
        .transform((value) => trimmedInputValues(value)),

    emailId: yup.string()
        .transform((value) => trimmedInputValues(value))
        .lowercase()
        .matches(EMAIL_REGEX_FORMAT, 'Please enter valid email')
        .required('Please enter user email'),
    
    ISDCode: yup.string()
        .transform((value) => trimmedInputValues(value))
        .required('Please select ISD Code'),

    phoneNumber: yup.string()
        .transform((value) => trimmedInputValues(value))
        .test('len', function(value) {
            const pmCompanyConfig = this.options.context
  
            const phoneNumberLength = pmCompanyConfig.phoneNumberLength
            const pinCodeErrorMessage = `Please enter valid phone number`
  
            if (value && !phoneNumberLength.includes(value.length)) {
              return this.createError({ message: pinCodeErrorMessage })
            }
            return true
        })
        .required('Please enter phone number'),

})
const userInitialState = {
    firstName: '',
    lastName: '',
    emailId: '',
    phoneNumber: '',
}

export { EditUserProfileValidationSchema, userInitialState };